export const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/pbnjikbncbjaaimelhlkfihgdkocmmei';
